export const configurationContent = `# Configuration

## \`<LightswitchProvider />\` props

| Prop              | Type             | Required | Description                                                           |
| ----------------- | ---------------- | -------- | --------------------------------------------------------------------- |
| \`publishableKey\`  | \`string\`         | ✅        | Frontend key for your app                                             |
| \`appSlug\`         | \`string\`         | ✅        | App identifier configured in Lightswitch                              |
| \`supabaseClient\`  | \`SupabaseClient\` | ✅        | Used to read current session                                          |
| \`autoShowPaywall\` | \`boolean\`        | ❌        | Automatically show paywall inside \`ProtectedRoute\` (default: \`false\`) |

## \`useLightswitchAuth()\` (hooks)

* \`handleLightswitchSignIn(redirectPath?: string): Promise<void>\`
* \`handleLightswitchSignUp(redirectPath?: string): Promise<void>\`

## \`ProtectedRoute\` (component)

Wrap any React subtree that must be entitled.`;
